import React from 'react';
import {
    BackAndSetItemContainer,
    DivPadding,
    ImageContainer,
    VerticalLineSeperator,
    BackTitle,
    HeaderFlexContainer,
    MarginAutoDiv
} from './SetDetails.styled';
import SetsAndItems from 'src/common/organisms/setsanditems/SetsAndItems';
import ImageButtonContainer from 'src/common/refactoredComponents/imageDisplay/ImageButtonContainer';
import ImageDisplay from 'src/common/refactoredComponents/imageDisplay';
import LeftArrow from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';

const SetItemDetailsImageSection = ({
    isCondensedView,
    previousCfn,
    showBackText,
    onBackClick,
    handleClose,
    backText,
    t,
    moreTemplates,
    sizes,
    data,
    isEquity,
    isOnlyPlusButton,
    onAddClick,
    index,
    openImagePopup,
    isSetDetail,
    isSurgery=false,
    id,
    isOrderDetail,
    isConsignmentAdd
}) => {
    const winWidth = window.innerWidth;
    const isMobile = winWidth <= sizes.mobileDevice;
    const hasImages = data?.productImages?.length > 0;

    return (
        <HeaderFlexContainer>
            <BackAndSetItemContainer
                width={
                    hasImages
                        ? data?.productImages?.length === 1
                            ? '80%'
                            : '70%'
                        : '100%'
                }
            >
                {!isCondensedView && !isMobile && (
                    previousCfn ? (
                        <BackTitle
                        id = {`setItemDetails-backto-${previousCfn?.bom || previousCfn?.cfn}`}
                            
                            onClick={() => onBackClick(previousCfn)}
                            marginLeft="-3px"  width={isCondensedView ? '90%' : undefined}
                        >
                            <img src={LeftArrow} alt="back" />
                            {`${t('common.backToText')} ${previousCfn?.bom || previousCfn?.cfn} `}
                        </BackTitle>
                    ) : showBackText ? (
                        <BackTitle
                        id = {`setItemDetails-backto-${id}`}
                            onClick={() =>
                                moreTemplates
                                    ? handleClose(false, true)
                                    : handleClose(false)
                            }
                            marginLeft="-3px"
                        >
                            <img src={LeftArrow} alt="back" />
                            {backText}
                        </BackTitle>
                    ) : null
                )}
                <DivPadding
                    padding={
                        isCondensedView && isMobile ? '13px' : '0px'
                    }
                    paddingBottom="0px"
                >
                    <SetsAndItems
                        isEquity={isEquity}
                        key={index}
                        isOnlyPlusButton={isOnlyPlusButton}
                      //  setNameFontSizeMobile="16px"
                        setOrItemDetails={data}
                        addCard={() => onAddClick(data)}
                        boxShadow="none"
                        showType
                        showBrand
                        contentPadding={
                            !isMobile ? '0 5px 10px 5px' : '0px'
                        }
                        marginOnLargeDevice="10px 5px 5px 0"
                        marginOnMediumDevice="10px -2px 5px 0"
                        isScheduleSurgery={isSurgery}
                        isOrderDetail={isOrderDetail}
                        isConsignmentAdd={isConsignmentAdd}
                    />
                </DivPadding>
            </BackAndSetItemContainer>
            {/* Desktop images */}
            {!isMobile && hasImages && (
                <ImageContainer
                    marginLeft={data?.productImages?.length === 1 ? '-35px' : undefined}
                >
                    <VerticalLineSeperator />
                    <ImageButtonContainer
                        data={data}
                        openImagePopup={openImagePopup}
                        centerMode
                        slideWidth={!isMobile ? '80%' : '150'}
                    />
                </ImageContainer>
            )}

            {/* Mobile images for set detail */}
            {isSetDetail && isMobile && hasImages && (
                !isCondensedView ? (
                    <div>
                        <ImageDisplay
                            images={data?.productImages}
                            height="150"
                            isMobile={true}
                        />
                    </div>
                ) : (
                    <ImageContainer width="70%" margin="auto">
                        <ImageButtonContainer
                            data={data}
                            centerMode={true}
                            width="150px"
                            height="150px"
                        />
                    </ImageContainer>
                )
            )}

            {/* Mobile images for item detail */}
            {!isSetDetail && isMobile && hasImages && (
                isCondensedView ? (
                    <MarginAutoDiv>
                        <img
                            src={`data:image/${data?.productImages[0].type};base64,${data.productImages[0].base64}`}
                            alt={`${data?.productImages[0]?.name} ${index + 1}`}
                            width="150px"
                            height="100px"
                            key={index}
                        />
                    </MarginAutoDiv>
                ) : (
                    <ImageDisplay
                        images={data?.productImages}
                        height="150"
                        isMobile={!isCondensedView}
                    />
                )
            )}
        </HeaderFlexContainer>
    );
};

export default SetItemDetailsImageSection;
